import { render, staticRenderFns } from "./AlarmDownNBandWIFI.vue?vue&type=template&id=6b2b2d90&"
import script from "./AlarmDownNBandWIFI.vue?vue&type=script&lang=js&"
export * from "./AlarmDownNBandWIFI.vue?vue&type=script&lang=js&"
import style0 from "./AlarmDownNBandWIFI.vue?vue&type=style&index=0&id=6b2b2d90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports